// src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Homepage from "./components/Homepage";
import MeetRecaps from "./components/MeetRecaps";
import FullGallery from "./components/FullGallery";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.css"; // Common CSS (if any)

// Single scroll authority for the app. A location with a hash (e.g. /#about)
// smooth-scrolls to that section; anything else resets to the top on navigation.
// Two rAFs let a freshly navigated route paint its sections before we scroll,
// so a cross-page jump (/full-gallery -> /#about) still lands correctly.
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const prefersReduced =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      let raf2;
      const raf1 = requestAnimationFrame(() => {
        raf2 = requestAnimationFrame(() => {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({
              behavior: prefersReduced ? "auto" : "smooth",
              block: "start",
            });
          }
        });
      });
      return () => {
        cancelAnimationFrame(raf1);
        if (raf2) cancelAnimationFrame(raf2);
      };
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return null;
}

// Only the homepage uses the shared <Header> banner. The routed destination
// pages (MeetRecaps, FullGallery) now own their own editorial hero, and About /
// Contact are homepage sections, so no other route renders a banner here.
function HeaderWithRoutes() {
  const { pathname } = useLocation();
  return pathname === "/" ? <Header /> : null;
}

function App() {
  return (
    <Router>
      <ScrollManager />
      <div className="App">
        <div className="background-overlay" />
        <Navbar />
        <HeaderWithRoutes />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/meet-recaps" element={<MeetRecaps />} />
            <Route path="/full-gallery" element={<FullGallery />} />
            {/* About and Contact moved into the homepage scroll; keep the old
                paths working for bookmarks/links by redirecting to the section. */}
            <Route path="/about" element={<Navigate to="/#about" replace />} />
            <Route
              path="/contact"
              element={<Navigate to="/#contact" replace />}
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
